"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAction = void 0;
function getAction(action_type, gif_id, tid, position, attributes) {
    if (attributes === void 0) { attributes = []; }
    if (position &&
        // apppend position only if it's not passed as a custom attribute
        !attributes.some(function (attributes) { return attributes.key === 'position'; })) {
        attributes.push({
            key: "position",
            value: JSON.stringify(position),
        });
    }
    return {
        action_type: action_type,
        ts: Date.now(),
        gif_id: gif_id,
        tid: tid,
        attributes: attributes,
    };
}
exports.getAction = getAction;
//# sourceMappingURL=util.js.map